"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getToggleCardUtilityClass = getToggleCardUtilityClass;
exports.toggleCardClasses = void 0;
var _base = require("@ori-ui/mui-bundle/base");
function getToggleCardUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriToggleCard', slot);
}
const toggleCardClasses = exports.toggleCardClasses = (0, _base.generateUtilityClasses)('MuiOriToggleCard', ['root', 'icon', 'input', 'indicator', 'disabled']);
var _default = exports.default = toggleCardClasses;
//# sourceMappingURL=toggleCardClasses.js.map